import { Image, List, Table, Text } from "@mantine/core";
import { Flex, StyledTh } from "src/styled";

import PreTextTable from "../PreTextTable/PreTextTable";
import { PreTextContainer } from "./PreTextCell.styled";
import { useTheme } from "../../../hooks";

interface IPretextObj {
  type: string;
  text: string;
  list?: IPretextObj[];
  horizontal?: boolean;
  vertical?: boolean;
  border?: boolean;
}

interface Props {
  pretext: IPretextObj;
}

const PreTextCell = ({ pretext }: Props) => {
  const theme = useTheme() as any;
  const { type, text, list, border, vertical } = pretext;

  const renderPreTextCell = () => {
    switch (type) {
      case "title":
        return (
          <Table>
            <StyledTh style={border === false ? { border: "none" } : {}}>
              <Text color="main.1">{text}</Text>
            </StyledTh>
          </Table>
        );
      case "text":
        return (
          <PreTextContainer style={border === false ? { border: "none" } : {}}>
            <Text>{text}</Text>
          </PreTextContainer>
        );
      case "bullet":
        return (
          <PreTextContainer style={border === false ? { border: "none" } : {}}>
            <List>
              <List.Item>
                <Text>{text}</Text>
              </List.Item>
            </List>
          </PreTextContainer>
        );
      case "image":
        return (
          <PreTextContainer style={border === false ? { border: "none" } : {}}>
            <Flex justify="center" align="center">
              <Image maw={500} src={text} />
            </Flex>
          </PreTextContainer>
        );
      case "table":
        return (
          <PreTextContainer style={border === false ? { border: "none" } : {}}>
            <PreTextTable tableObject={JSON.parse(text)} />
          </PreTextContainer>
        );
      default:
        if (list) {
          return (
            <Flex direction={vertical ? "column" : "row"} align="center">
              {list.map((item, index) => (
                <PreTextCell key={index} pretext={{ ...item, border: false }} />
              ))}
            </Flex>
          );
        }
        break;
    }
  };

  return (
    <Table
      style={{
        ...(list && border !== false
          ? {
              border: `1px solid ${theme.colors.main[9]}`,
              borderTop: "none",
            }
          : {}),
        pageBreakInside: "avoid",
      }}>
      {renderPreTextCell()}
    </Table>
  );
};

export default PreTextCell;
